import { render, staticRenderFns } from "./ChangeDelegation.vue?vue&type=template&id=f5c27d66&scoped=true"
import script from "./ChangeDelegation.vue?vue&type=script&lang=js"
export * from "./ChangeDelegation.vue?vue&type=script&lang=js"
import style0 from "./ChangeDelegation.vue?vue&type=style&index=0&id=f5c27d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c27d66",
  null
  
)

export default component.exports